import {useState, useCallback, useEffect} from "react";
import {useHistory} from "react-router-dom";
let logoutTimer;

export const useAuth = () => {
  const [token, setToken] = useState();
  const [tokenExpirationDate, setTokenExpirationDate] = useState();
  const [userId, setUserId] = useState(false);
  const [role, setRole] = useState("");
  const history = useHistory();

  const canEditDelete = (data_userID) => {
    if (data_userID === userId) return true;
    if ("admin" === userId) return true;
    return false;
  };

  const isSuperAdmin = () => {
    if ("admin" === userId) return true;
    return false;
  };

  const canInsert = () => {
    if ("admin" === role) return true;
    return false;
  };

  const login = useCallback((uid, token, role, expirationDate) => {
    setToken(token);
    setUserId(uid);
    setRole(role);
    const tokenExpirationDate = expirationDate || new Date(new Date().getTime() + 1000 * 60 * 60);
    setTokenExpirationDate(tokenExpirationDate);
    localStorage.setItem(
      "userData",
      JSON.stringify({
        userId: uid,
        token: token,
        role: role,
        expiration: tokenExpirationDate.toISOString(),
      })
    );
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setTokenExpirationDate(null);
    setUserId(null);
    localStorage.removeItem("userData");
  }, []);

  useEffect(() => {
    if (token && tokenExpirationDate) {
      const remainingTime = tokenExpirationDate.getTime() - new Date().getTime();
      logoutTimer = setTimeout(logout, remainingTime);
    } else {
      clearTimeout(logoutTimer);
    }
  }, [token, logout, tokenExpirationDate]);

  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("userData"));
    if (storedData && storedData.token && new Date(storedData.expiration) > new Date()) {
      login(storedData.userId, storedData.token, storedData.role, new Date(storedData.expiration));
    }
  }, [login]);

  return {token, login, logout, userId, role, canEditDelete, canInsert, isSuperAdmin};
};
